<template>
	<BaseAuthUser v-slot="{urls, currentUrl}">
		<ul class="auth-sidebar-nav" ref="authMenu">
			<li :class="{'active': urls.auth_my_webshoporder == currentUrl}">
				<NuxtLink :to="urls.auth_my_webshoporder" class="my-orders">
					<BaseCmsLabel tag="span" code="my_orders" />
				</NuxtLink>
			</li>
			<li :class="{'active': urls.auth_my_webshopcoupon == currentUrl}">
				<NuxtLink :to="urls.auth_my_webshopcoupon" class="my-coupons">
					<BaseCmsLabel tag="span" code="my_coupons" />
				</NuxtLink>
			</li>
			<li :class="{'active': urls.auth_edit == currentUrl}">
				<NuxtLink :to="urls.auth_edit" class="my-profile-edit">
					<BaseCmsLabel tag="span" code="my_profile" />
				</NuxtLink>
			</li>
			<li :class="{'active': urls.auth_change_password == currentUrl}">
				<NuxtLink :to="urls.auth_change_password" class="my-password">
					<BaseCmsLabel tag="span" code="password" />
				</NuxtLink>
			</li>
			<li>
				<NuxtLink :to="`${urls.auth_logout}?redirect=/`" class="my-logout">
					<BaseCmsLabel tag="span" code="logout" />
				</NuxtLink>
			</li>
		</ul>
	</BaseAuthUser>
</template>

<script setup>
	const {mobileBreakpoint} = inject('rwd');
	const authMenu = ref();
	onMounted(async () => {
		//mobile container scroll
		setTimeout(() => {
			if (authMenu.value && mobileBreakpoint) {
				const activeItem = authMenu.value.querySelector('.auth-sidebar-nav li.active');
				if (activeItem) {
					const container = authMenu.value;
					let scrollLeft = activeItem.getBoundingClientRect().left - container.getBoundingClientRect().left - 38;

					container.scrollTo({
						left: scrollLeft,
						behavior: 'smooth'
					});
				}
			}
		}, 500);
	});
</script>

<style lang="less" scoped>
	.auth-sidebar-nav{
		list-style: none; font-size: 14px; line-height: 20px; font-weight: bold; color: var(--blue); margin: 0; border-radius: var(--borderRadius); box-shadow: 0 5px 30px 0 rgba(0,0,0,0.04);
		li{
			@media (min-width: @m){
				&:first-child a{border-radius: 6px 6px 0 0;}
				&:last-child a{border-radius: 0 0 6px 6px;}
			}
			&.active{
				a{
					color: #fff; border-color: var(--blue2); background: var(--blue2);
					&:before{color: #fff;}
				}
			}
			@media (min-width: @h){
				&:hover{
					&:not(.active){
						a{
							background: var(--lightGray);
							&:after{opacity: 1;}
						}
					}
				}
			}
		}
		a{
			position: relative; display: flex; align-items: center; width: 100%; text-decoration: none; color: var(--blue); background: #fff; padding: 18px 23px 18px 58px; margin-top: -1px; border: 1px solid var(--gray); .transition(color);
			&:before{.icon-cart(); font: 21px/1 var(--fonti); color: var(--blue); position: absolute; left: 25px; top: 15px;}
			&:after{.icon-arrow(); font: 10px/1 var(--fonti); opacity: 0; .transition(opacity); position: absolute; top: 23px; right: 23px;}

			&.my-coupons:before{.icon-coupon(); font-size: 15px; top: 19px; left: 24px;}
			&.my-profile-edit:before{.icon-edit(); font-size: 20px; left: 26px;}
			&.my-password:before{.icon-password(); font-size: 24px; top: 16px; left: 24px;}
			&.my-logout:before{.icon-logout(); font-size: 17px; top: 19px; left: 28px;}
		}
		@media (max-width: @m){
			display: flex; gap: 10px; margin: 0 -16px; padding: 1px 16px 0; overflow-x: auto; box-shadow: none;
			&::-webkit-scrollbar {-webkit-appearance: none; height: 0;}
			&::-webkit-scrollbar-thumb {background-color: transparent;}	
			li{flex-grow: 0; flex-shrink: 0;}
			a{
				border-radius: 3px; padding: 14px 16px 12px 43px;
				&:before{font-size: 18px; left: 16px; top: 13px;}
				&.my-coupons:before{.icon-coupon(); font-size: 13px; left: 16px; top: 17px;}
				&.my-profile-edit:before{.icon-edit(); font-size: 17px; left: 16px; top: 14px;}
				&.my-password:before{.icon-password(); font-size: 20px; top: 14px; left: 16px;}
				&.my-logout:before{.icon-logout(); font-size: 17px; top: 15px; left: 16px;}
			}	
		}
	}
</style>
